import vueI18nMixin from './vue-i18n-mixin';
import readonly from './readonly';

export default [vueI18nMixin, readonly];
